/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PerformanceIndicatorPollBatchUserReport = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The PerformanceIndicatorPollBatchUserReport model module.
   * @module model/PerformanceIndicatorPollBatchUserReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>PerformanceIndicatorPollBatchUserReport</code>.
   * @alias module:model/PerformanceIndicatorPollBatchUserReport
   * @class
   */
  var exports = function() {
    var _this = this;








  };

  /**
   * Constructs a <code>PerformanceIndicatorPollBatchUserReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PerformanceIndicatorPollBatchUserReport} obj Optional instance to populate.
   * @return {module:model/PerformanceIndicatorPollBatchUserReport} The populated <code>PerformanceIndicatorPollBatchUserReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('BatchCreated')) {
        obj['BatchCreated'] = ApiClient.convertToType(data['BatchCreated'], 'Date');
      }
      if (data.hasOwnProperty('PollBatchID')) {
        obj['PollBatchID'] = ApiClient.convertToType(data['PollBatchID'], 'Integer');
      }
      if (data.hasOwnProperty('UserID')) {
        obj['UserID'] = ApiClient.convertToType(data['UserID'], 'Integer');
      }
      if (data.hasOwnProperty('DateResponded')) {
        obj['DateResponded'] = ApiClient.convertToType(data['DateResponded'], 'Date');
      }
      if (data.hasOwnProperty('ResponseValue')) {
        obj['ResponseValue'] = ApiClient.convertToType(data['ResponseValue'], 'Number');
      }
      if (data.hasOwnProperty('Comment')) {
        obj['Comment'] = ApiClient.convertToType(data['Comment'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Date} BatchCreated
   */
  exports.prototype['BatchCreated'] = undefined;
  /**
   * @member {Integer} PollBatchID
   * @default 0
   */
  exports.prototype['PollBatchID'] = 0;
  /**
   * @member {Integer} UserID
   * @default 0
   */
  exports.prototype['UserID'] = 0;
  /**
   * @member {Date} DateResponded
   */
  exports.prototype['DateResponded'] = undefined;
  /**
   * @member {Number} ResponseValue
   */
  exports.prototype['ResponseValue'] = undefined;
  /**
   * @member {String} Comment
   * @default ''
   */
  exports.prototype['Comment'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


